<template>
  <div>
    <v-navigation-drawer 
      app
      permanent
      clipped
      color="secondary"
      width="300px"
      class="pt-6"
      v-bind="$attrs"
    >
      <div class="px-5">
        <!-- Time and Date -->
        <v-row>
          <!-- Date -->
          <v-col
            cols="6"
            class="secondary--text text--darken-4 font-weight-bold">
            {{ currentDate }}, {{ currentDay }}
          </v-col>
          <!-- Time -->
          <v-col
            cols="6"
            class="primary--text text-right font-weight-bold">
            {{ currentTime }}
          </v-col>
        </v-row>
        <!-- search field -->
        <!-- <v-text-field
          v-model="filter"
          dense
          rounded
          hide-details
          prepend-inner-icon="mdi-magnify"
          placeholder="Search"
          class="white py-2"
        ></v-text-field> -->

        <patient-profile
          height="75vh"
          content-height="85%"
          class="mt-5"
        ></patient-profile>
      </div>   
    </v-navigation-drawer>
  </div>
</template>

<script>

  export default {
    name: 'Sidebar',

    components: {
      PatientProfile: () => import('./CasePatientProfile.vue')
    },

    data() {
      return {
        filter: '',
        now: {
          intervalId : null,
          dateTime: new Date(),
        },
        detail: {
          show: false,
          index: null
        }
      }
    },

    computed: {
      currentDate() {
        const config = { month: 'short', day: 'numeric' };
        return this.now.dateTime.toLocaleString('default', config);
      },
      currentDay() {
        const config = { weekday: 'short' };
        return this.now.dateTime.toLocaleString('default', config);
      },
      currentTime() {
        const config = { hour: '2-digit', minute: '2-digit' };
        return this.now.dateTime.toLocaleString('default', config);
      },
      filteredCases() {
        return false
        // return this.cases.filter(item => {
        //   var filter = this.filter.toLowerCase()
        //   return (
        //        item.patient.toLowerCase().includes(filter)
        //     || item.title.toLowerCase().includes(filter)
        //     || item.case_number.toLowerCase().includes(filter)
        //   )
        // })
      }
    },

    methods: {
      showDetailPopup(index) {
        this.detail.show = true
        this.detail.index = index
      },
      hideDetailPopup() {
        this.detail.show = false
        this.detail.index = null
      },
      
      /** HELPERS */
      consolelog(nI) {
        console.log(nI)
      },
    },

    mounted() {
      // updates time every 1 minute
      this.now.intervalId = setInterval(()=>{
        this.now.dateTime = new Date()
      },60000);
    },

    beforeDestroy() {
      // clears interval to prevent leak and unreachable interval stacks
      clearInterval(this.now.intervalId);
    }
  }
</script>

<style scoped>
</style>